@if (package) {
  @for (toolbar of package.toolbars; track toolbar) {
    @if (!hideToolTypes.includes(toolbar.type)) {
      @switch (toolbar.mode) {
        @case ('CLICK') {
          <button
            mat-icon-button
            [matTooltip]="toolbar.tooltip"
            element-ref
            #elementRef="elementRef"
            (click)="package.insert(toolbar.onClick(package, elementRef))"
            [disabled]="disableToolTypes.includes(toolbar.type)"
            [attr.data-testid]="'click-toolbar-button-' + toolbar.type"
          >
            <icon
              [attr.data-testid]="'click-toolbar-icon-' + toolbar.type"
              [icon]="toolbar.icon"
            ></icon>
          </button>
        }
        @case ('UPLOAD_FILE') {
          <button
            mat-icon-button
            (file)="package.insert(toolbar.onUpload($event))"
            [accept]="toolbar.accept"
            [matTooltip]="toolbar.label + ' - ' + toolbar.tooltip"
            matTooltipPosition="after"
            [disabled]="disableToolTypes.includes(toolbar.type)"
            [attr.data-testid]="'upload-toolbar-button-' + toolbar.type"
          >
            <icon
              [attr.data-testid]="'upload-toolbar-icon-' + toolbar.type"
              [icon]="toolbar.icon"
            ></icon>
          </button>
        }
        @case ('SUBMENU') {
          <button
            mat-icon-button
            [matTooltip]="toolbar.tooltip"
            [matMenuTriggerFor]="menu.matMenu"
            (click)="loadSubmenu(toolbar)"
            [disabled]="disableToolTypes.includes(toolbar.type)"
            [attr.data-testid]="'submenu-toolbar-button-' + toolbar.type"
          >
            <icon
              [attr.data-testid]="'submenu-toolbar-icon-' + toolbar.type"
              [icon]="toolbar.icon"
            ></icon>
          </button>
          <ms-submenu
            #menu
            [toolbars]="toolbar.submenu"
            [package]="package"
            [attr.data-testid]="'submenu-' + toolbar.type"
          ></ms-submenu>
        }
      }
    }
  }
}
